// The single definition of "which variants does a buyer get to see".
//
// This lived inline in VariantPanel.render(). Every other surface that lists
// variants — the VR menu, voice commands, the variant sheet — has to apply the
// same two rules or it will offer something the chip bar deliberately hides.
// The `generated_*` case is the one that matters: those chips are suppressed for
// client presentation, so a second list that forgot the rule would surface raw AI
// output in front of a buyer.

import type { Room, Variant } from './types';

/** A "before" variant is reached through the Antes/Depois toggle, not a chip. */
export function isVisibleVariant(variant: Variant): boolean {
  if (variant.isBefore) return false;
  // AI-generated variants ("Gerado · *", "Repintado · *", "Móvel · *",
  // "Aprimorado · *") stay in localStorage + Vercel Blob and remain reachable
  // through the variants gallery — only the inline chip is suppressed.
  if (variant.id.startsWith('generated_')) return false;
  return true;
}

export function visibleVariants(room: Room): Variant[] {
  return room.variants.filter(isVisibleVariant);
}
